import { type } from "jquery";

export const CorrectionTableHelpers = {
  data() {
    return {
      tableColumns: [
        {
          title: 'Banco',
          type: 'custom-html',
          key: 'bank',
          modifier: (value) => {
            if (value) {
              return value.name;
            } else {
              return 'N/A';
            }
          }
        },
        {
          title: 'Tipo de Transacción',
          type: 'custom-html',
          key: 'transactiontype',
          modifier: (value) => {
            if (value) {
              return value.name;
            } else {
              return 'N/A';
            }
          }
        },
        {
          title: 'Fecha Pago',
          type: 'custom-html',
          key: 'date',
          modifier: (value) => {
            if (value) {
              return moment(value).format("YYYY-MM-DD");
            } else {
              return 'N/A';
            }
          }
        },
        {
          title: 'Tipo',
          type: 'custom-html',
          key: 'type',
          modifier: (value) => {
            let type = 'OTRO';
            if (value === 'S') {
              type = 'SOLICITUD';
            } else if (value === 'P') {
              type = 'PROFORMA';
            }
            return type;
          }
        },
        {
          title: 'Convenio',
          type: 'custom-html',
          key: 'is_agreement',
          modifier: (value) => {
            let type = 'NO';
            if (value) {
              type = 'SI ';
            }
            return type;
          }
        },
        {
          title: 'Observaciones',
          type: 'custom-html',
          key: 'observations',
          modifier: (value) => {
            return `<span class="badge badge-sm badge-pill badge-danger">${value}</span>`;
          }
        },
        {
          title: 'Días Disponibles',
          type: 'custom-html',
          key: 'accreditation_application',
          modifier: (value) => {
            let tmp;
            if (value.accreditation_time) {
              if (value.accreditation_time.remaining_days > 1) {
                tmp = `<span class="badge badge-sm badge-pill badge-success">${value.accreditation_time.remaining_days}</span>`;
              }
              if (value.accreditation_time.remaining_days == 1) {
                tmp = `<span class="badge badge-sm badge-pill badge-warning">${value.accreditation_time.remaining_days}</span>`;
              }
              if (value.accreditation_time.remaining_days == 0) {
                tmp = `<span class="badge badge-sm badge-pill badge-danger">${value.accreditation_time.remaining_days}</span>`;
              }
            }
            return tmp;
          }
        },
        {
          title: 'Agrupado',
          type: 'custom-html',
          key: 'eval_test',
          modifier: (item) => {
            if (item) {
              if (item.key_combo) {
                return `<span class="badge badge-sm badge-pill badge-primary">Por ${item.key_combo}</span>`;
              } else {
                return 'N/A';
              }
            } else {
              return 'N/A';
            }
          }
        },
      ],
      actionObj: {
        title: 'Acciones',
        type: 'action',
      }
    }
  },
}